/* eslint-disable no-useless-escape */
import React from 'react';
import PropTypes from 'prop-types';
import FormText from 'components/pages/ResourceSetting/Widgets/FormText';

const YoutubeRegex = new RegExp(/^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/);

export default function YoutubeUrlField({
  value,
  onChange,
  disabled,
  required,
}) {
  return (
    <FormText
      value={value}
      onChange={onChange}
      disabled={disabled}
      required={required}
      singleLine="true"
      valid={!value || YoutubeRegex.test(value)}
    />
  );
}

YoutubeUrlField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
};

YoutubeUrlField.defaultProps = {
  value: '',
  onChange: () => {},
  disabled: false,
  required: false,
};
